import { notificationEventApi, registerFcmTokenApi } from "../ENV";
import { fetchApi } from "./FetchAPI";
import { getUserToken } from "./Utils";

export const NotificationEvent = {
  opened: "opened",
  clicked: "clicked",
  clickThrough: "click_through",
};

export const NOTIFICATION_CAMPAIGN_PARAM = "notification_campaign";
export const NOTIFICATION_CLICKED_MESSAGE = "NOTIFICATION_CLICKED";

const DEEP_LINK_ROUTES = {
  "app://chatbot": "/chat",
};

const REPORTED_EVENTS_KEY = "reportedNotificationEvents";

export function resolveDeepLink(deepLink) {
  return DEEP_LINK_ROUTES[deepLink] || "/chat";
}

function getReportedEvents() {
  try {
    return JSON.parse(sessionStorage.getItem(REPORTED_EVENTS_KEY)) || [];
  } catch (e) {
    return [];
  }
}

// The same campaign can reach the app through several paths at once (foreground
// message, service worker message, URL param), so events are reported once per session.
function isAlreadyReported(campaignId, event) {
  return getReportedEvents().includes(`${campaignId}:${event}`);
}

function markAsReported(campaignId, event) {
  try {
    const reported = getReportedEvents();
    reported.push(`${campaignId}:${event}`);
    sessionStorage.setItem(REPORTED_EVENTS_KEY, JSON.stringify(reported));
  } catch (e) {
    console.error("Failed to store reported notification event", e);
  }
}

export async function registerFcmToken(fcmToken) {
  const token = getUserToken();
  if (!token || !fcmToken) return null;

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": token,
  };

  try {
    const res = await fetchApi(
      registerFcmTokenApi,
      "POST",
      JSON.stringify({ fcm_token: fcmToken }),
      headerValue,
      {}
    );
    return res;
  } catch (e) {
    console.error("Failed to register FCM token", e);
    return null;
  }
}

export async function reportNotificationEvent(campaignId, event) {
  const token = getUserToken();
  if (!token || !campaignId || !event) return null;
  if (isAlreadyReported(campaignId, event)) return null;

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": token,
  };

  try {
    markAsReported(campaignId, event);
    const res = await fetchApi(
      notificationEventApi,
      "POST",
      JSON.stringify({ campaign_id: campaignId, event: event }),
      headerValue,
      {}
    );
    return res;
  } catch (e) {
    console.error("Failed to report notification event", e);
    return null;
  }
}
